import { createContext } from "react";
import { MappedEvent, ResultsFormattedData } from "@data-types/results";

export const ResultsContextMobile = createContext(
	{} as ResultsFormattedData<MappedEvent[]>
);
